import * as React from 'react';
import * as main from "../../main.module.scss";
import * as get from "./style.module.scss";
export const Get = () => {
  return (
    <section className={`${get.get} container`}>
      <div>
        <h2 className={main.title}>Что я получу:</h2>
        <div className={get.dialog}>
          <div className={get.pseudo}>
            <div className={get.pseudoTriangle}></div>
          </div>
          <p className={get.text}>Затрачивая всего 15-20 минут в день, вы узнаете, как сделать так, чтобы ваш ребенок:</p>
          <ul>
            <li>
              <p>Научился читать быстрее в 1,5-2 раза и понимать прочитанное;</p>
            </li>
            <li>
              <p>Улучшил память, внимание и мышление;</p>
            </li>
            <li>
              <p>Повысил успеваемость в школе;</p>
            </li>
            <li>
              <p>Загорелся любовью к чтению.</p>
            </li>
          </ul>
        </div>
      </div>
      <img src="https://fs.advance.ru/landing-pages/webinar/kak_nauchit_rebenka_chitat/i-get.png" alt=""/>
    </section>
  );
};
